<template lang="html">
    <entity-page id="page__document" v-loader-overlay="progress">
        <template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded @click="back"></z-icon-button>
        </template>
        <doc v-if="document && document.id" v-bind:document="document" v-bind:deal="document.deal" v-on:refresh-doc="getDocument" />
    </entity-page>
</template>
<script>
    import Doc from './components/Doc';
    import EntityPage  from '@/components/EntityPage.vue';
    import ZIconButton from '@/components/ZIconButton.vue';
    export default {
        components: {Doc, EntityPage, ZIconButton},
        watch: {
            '$route.params.id'() {
                this.getDocument();
            }
        },
        computed: {
            /**
             * Флаг закгрузки текущего компонента
             */
            progress() {
                return this.progressObj['load-document-card'];
            },
            /**
             * Объект с флагами загрузки 
             */
            progressObj() {
                return this.$store.state.progressObj;
            },            
            document() {
                return this.$store.state.deals.document;
            }
        },
        methods: {
            getDocument() {
                this.$store.commit('showProgressBar', 'load-document-card');
                this.$store.commit('openRightPanel');
                this.$store.commit('setRightPanelWidth', 1200);
                this.$store.dispatch('deals/getDocument', this.$route.params.id)
                    .finally(() => this.$store.commit('hideProgressBar', 'load-document-card'));
            },
            back() {
                this.$router.push({ name: 'Documents', query: this.$route.query });
            }
        },
        created() {
            this.getDocument();
        }
    }
</script>
<style lang="sass"></style>


// WEBPACK FOOTER //
// Document.vue?5c0b429c